const EmployeeAbsneceDashboard = ({ data = [] }) => {
    return (
        <div dir="rtl" className="w-[80vw] max-w-4xl p-4 text-gray-800">
            <h1 className="mb-4 text-xl font-bold text-center">غياب الموظفين</h1>

            <div className="overflow-x-auto rounded-xl border">
                <table className="w-full border-collapse text-center text-sm">
                    <thead>
                        <tr className="bg-sky-600 text-white">
                            <th className="border p-2">م</th>
                            <th className="border p-2">الاسم</th>
                            <th className="border p-2">الوظيفة</th>
                            <th className="border p-2">الجهة</th>
                            <th className="border p-2">تاريخ الغياب</th>
                            <th className="border p-2">السبب</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-slate-50"}>
                                <td className="border p-2">{index + 1}</td>
                                <td className="border p-2 font-bold">
                                    {[item.employee?.first_name, item.employee?.middle_name, item.employee?.last_name]
                                        .filter(Boolean)
                                        .join(" ")}
                                </td>
                                <td className="border p-2">{item.employee?.role?.title || "-"}</td>
                                <td className="border p-2">{item.employee?.organization?.name || "-"}</td>
                                <td className="border p-2">{item.absence_date || "-"}</td>
                                <td className="border p-2">{item.cause || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmployeeAbsneceDashboard;
